export const useAvatar = (name: string): string => {
    return `https://ui-avatars.com/api/?name=${name}&color=000&background=FFF&size=24`
}

export const useUserAvatar = (name: string): string => {
    return `https://ui-avatars.com/api/?name=${name}&color=000&background=f5f5f5`
}

export const useUserCover = (name: string): string => {
    return `https://ui-avatars.com/api/?name=${name}&color=000&background=f5f5f5&size=256`
}
